<template>
  <!-- 通用样式 -->
  <header class="header">
    <section class="header-content">
      <h1 class="logo">
        <a href="/zh" v-if="$t('m.lang') == 'zh'"><em class="logo-icon">SKYBOX</em><em class="logo-text">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.4 13.9" :class="{ innerlogo: svgColor }">
              <path
                d="M0.5 12.1C0.2 11.9 0 11.6 0 11.2c0-0.6 0.5-1.1 1.1-1.1 0.3 0 0.5 0.1 0.7 0.2 1.1 0.9 2.3 1.4 3.8 1.4s2.4-0.7 2.4-1.7v0c0-1-0.5-1.5-3-2C2 7.3 0.4 6.4 0.4 4v0C0.4 1.6 2.4 0 5 0c1.7 0 3 0.4 4.3 1.2 0.3 0.2 0.5 0.5 0.5 0.9 0 0.6-0.5 1.1-1.1 1.1 -0.2 0-0.4-0.1-0.6-0.2 -1-0.7-2-1-3.1-1 -1.4 0-2.2 0.7-2.2 1.6v0c0 1 0.6 1.5 3.2 2.1 2.8 0.7 4.3 1.7 4.3 3.9v0c0 2.5-2 4-4.8 4C3.7 13.8 2 13.3 0.5 12.1z">
              </path>
              <path
                d="M12.2 1.3c0-0.7 0.5-1.2 1.2-1.2 0.7 0 1.2 0.5 1.2 1.2V7l6.4-6.4c0.3-0.3 0.6-0.4 1-0.4 0.7 0 1.1 0.5 1.1 1.1 0 0.4-0.2 0.6-0.4 0.9l-4.2 4 4.5 5.6c0.2 0.2 0.3 0.5 0.3 0.8 0 0.7-0.5 1.1-1.2 1.1 -0.5 0-0.7-0.2-1-0.6l-4.3-5.5 -2.2 2.1v2.8c0 0.7-0.5 1.2-1.2 1.2 -0.7 0-1.2-0.5-1.2-1.2V1.3z">
              </path>
              <path
                d="M28.7 8.4l-4.6-6.3c-0.2-0.2-0.3-0.5-0.3-0.8 0-0.6 0.5-1.1 1.2-1.1 0.5 0 0.9 0.3 1.1 0.7l3.7 5.4 3.8-5.4c0.3-0.4 0.6-0.7 1.1-0.7 0.7 0 1.1 0.5 1.1 1.1 0 0.3-0.2 0.6-0.3 0.8l-4.6 6.3v4.2c0 0.7-0.5 1.2-1.2 1.2 -0.7 0-1.2-0.5-1.2-1.2V8.4z">
              </path>
              <path
                d="M37.8 1.4c0-0.7 0.5-1.2 1.2-1.2h4.8c1.5 0 2.7 0.4 3.5 1.2 0.6 0.6 0.9 1.3 0.9 2.2v0c0 1.6-0.9 2.5-1.9 3 1.6 0.5 2.7 1.4 2.7 3.3v0c0 2.4-2 3.7-5 3.7h-5c-0.7 0-1.2-0.5-1.2-1.2V1.4zM43.3 5.9c1.5 0 2.5-0.6 2.5-1.8v0c0-1.1-0.8-1.7-2.4-1.7h-3.4v3.6H43.3zM44 11.5c1.6 0 2.6-0.6 2.6-1.8v0c0-1.1-0.9-1.8-2.8-1.8h-3.7v3.7H44z">
              </path>
              <path
                d="M50.2 7L50.2 7c0-3.8 2.9-7 7-7s7 3.1 7 6.9v0c0 3.8-2.9 6.9-7 6.9S50.2 10.7 50.2 7zM61.7 7L61.7 7c0-2.6-1.9-4.8-4.6-4.8 -2.7 0-4.5 2.1-4.5 4.7v0c0 2.6 1.9 4.7 4.6 4.7C59.8 11.7 61.7 9.6 61.7 7z">
              </path>
              <path
                d="M65.2 11.8l4-4.9 -3.8-4.7c-0.2-0.2-0.4-0.6-0.4-0.9 0-0.7 0.5-1.1 1.2-1.1 0.5 0 0.8 0.2 1.1 0.6l3.4 4.5L74 0.8c0.3-0.4 0.6-0.7 1.1-0.7s1.1 0.4 1.1 1.1c0 0.3-0.1 0.6-0.4 0.9l-3.8 4.7 3.9 4.9c0.2 0.2 0.4 0.5 0.4 0.9 0 0.7-0.5 1.1-1.2 1.1 -0.5 0-0.8-0.2-1.1-0.6l-3.6-4.7 -3.5 4.6c-0.3 0.4-0.6 0.7-1.1 0.7 -0.5 0-1.1-0.4-1.1-1.1C64.8 12.3 65 12 65.2 11.8z">
              </path>
            </svg></em>
        </a>
        <a href="/" v-if="$t('m.lang') == 'en'"><em class="logo-icon">SKYBOX</em><em class="logo-text">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.4 13.9" :class="{ innerlogo: svgColor }">
              <path
                d="M0.5 12.1C0.2 11.9 0 11.6 0 11.2c0-0.6 0.5-1.1 1.1-1.1 0.3 0 0.5 0.1 0.7 0.2 1.1 0.9 2.3 1.4 3.8 1.4s2.4-0.7 2.4-1.7v0c0-1-0.5-1.5-3-2C2 7.3 0.4 6.4 0.4 4v0C0.4 1.6 2.4 0 5 0c1.7 0 3 0.4 4.3 1.2 0.3 0.2 0.5 0.5 0.5 0.9 0 0.6-0.5 1.1-1.1 1.1 -0.2 0-0.4-0.1-0.6-0.2 -1-0.7-2-1-3.1-1 -1.4 0-2.2 0.7-2.2 1.6v0c0 1 0.6 1.5 3.2 2.1 2.8 0.7 4.3 1.7 4.3 3.9v0c0 2.5-2 4-4.8 4C3.7 13.8 2 13.3 0.5 12.1z">
              </path>
              <path
                d="M12.2 1.3c0-0.7 0.5-1.2 1.2-1.2 0.7 0 1.2 0.5 1.2 1.2V7l6.4-6.4c0.3-0.3 0.6-0.4 1-0.4 0.7 0 1.1 0.5 1.1 1.1 0 0.4-0.2 0.6-0.4 0.9l-4.2 4 4.5 5.6c0.2 0.2 0.3 0.5 0.3 0.8 0 0.7-0.5 1.1-1.2 1.1 -0.5 0-0.7-0.2-1-0.6l-4.3-5.5 -2.2 2.1v2.8c0 0.7-0.5 1.2-1.2 1.2 -0.7 0-1.2-0.5-1.2-1.2V1.3z">
              </path>
              <path
                d="M28.7 8.4l-4.6-6.3c-0.2-0.2-0.3-0.5-0.3-0.8 0-0.6 0.5-1.1 1.2-1.1 0.5 0 0.9 0.3 1.1 0.7l3.7 5.4 3.8-5.4c0.3-0.4 0.6-0.7 1.1-0.7 0.7 0 1.1 0.5 1.1 1.1 0 0.3-0.2 0.6-0.3 0.8l-4.6 6.3v4.2c0 0.7-0.5 1.2-1.2 1.2 -0.7 0-1.2-0.5-1.2-1.2V8.4z">
              </path>
              <path
                d="M37.8 1.4c0-0.7 0.5-1.2 1.2-1.2h4.8c1.5 0 2.7 0.4 3.5 1.2 0.6 0.6 0.9 1.3 0.9 2.2v0c0 1.6-0.9 2.5-1.9 3 1.6 0.5 2.7 1.4 2.7 3.3v0c0 2.4-2 3.7-5 3.7h-5c-0.7 0-1.2-0.5-1.2-1.2V1.4zM43.3 5.9c1.5 0 2.5-0.6 2.5-1.8v0c0-1.1-0.8-1.7-2.4-1.7h-3.4v3.6H43.3zM44 11.5c1.6 0 2.6-0.6 2.6-1.8v0c0-1.1-0.9-1.8-2.8-1.8h-3.7v3.7H44z">
              </path>
              <path
                d="M50.2 7L50.2 7c0-3.8 2.9-7 7-7s7 3.1 7 6.9v0c0 3.8-2.9 6.9-7 6.9S50.2 10.7 50.2 7zM61.7 7L61.7 7c0-2.6-1.9-4.8-4.6-4.8 -2.7 0-4.5 2.1-4.5 4.7v0c0 2.6 1.9 4.7 4.6 4.7C59.8 11.7 61.7 9.6 61.7 7z">
              </path>
              <path
                d="M65.2 11.8l4-4.9 -3.8-4.7c-0.2-0.2-0.4-0.6-0.4-0.9 0-0.7 0.5-1.1 1.2-1.1 0.5 0 0.8 0.2 1.1 0.6l3.4 4.5L74 0.8c0.3-0.4 0.6-0.7 1.1-0.7s1.1 0.4 1.1 1.1c0 0.3-0.1 0.6-0.4 0.9l-3.8 4.7 3.9 4.9c0.2 0.2 0.4 0.5 0.4 0.9 0 0.7-0.5 1.1-1.2 1.1 -0.5 0-0.8-0.2-1.1-0.6l-3.6-4.7 -3.5 4.6c-0.3 0.4-0.6 0.7-1.1 0.7 -0.5 0-1.1-0.4-1.1-1.1C64.8 12.3 65 12 65.2 11.8z">
              </path>
            </svg></em>
        </a>
      </h1>
      <transition name="fade">
        <div class="nav-toggle" @click="navShow()">
          <span class="icon-nav-collapse">navigation of skybox</span>
          <span class="icon-nav-exit" :style="{ display: iconShow }">close</span>
        </div>
      </transition>
      <p class="btn-buy">
        <a @click="tpGet()" class="btn-buy-now" v-if="$t('m.lang') == 'en'">
          <span class="icon">
            <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.14 13.44"
              style="width: 16px; height: 13.325px">
              <title>buy now</title>
              <path class="path-fill"
                d="M14.75,8.75H6.36L3.49.38A.56.56,0,0,0,3,0H.56A.67.67,0,0,0,0,.67a.64.64,0,0,0,.56.65h2L5.43,9.67a.56.56,0,0,0,.53.38h8.78a.72.72,0,0,0,.67-.63A.76.76,0,0,0,14.75,8.75Zm.89-7.13-9.87-.3a.35.35,0,0,0-.37.51L7,7a.76.76,0,0,0,.76.41H15a.65.65,0,0,0,.63-.56l.52-4.62A.51.51,0,0,0,15.64,1.62Zm-2.23,9.12a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,13.41,10.74Zm-5.34,0a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,8.07,10.74Z">
              </path>
            </svg></span>
          <span class="buy-now-txt">{{ $t("m.header.buynow") }}</span>
        </a>
        <a @click="tpGetZh()" class="btn-buy-now" v-if="$t('m.lang') == 'zh'">
          <span class="icon">
            <svg id="图层_1" data-name="图层 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.14 13.44"
              style="width: 16px; height: 13.325px">
              <title>buy now</title>
              <path class="path-fill"
                d="M14.75,8.75H6.36L3.49.38A.56.56,0,0,0,3,0H.56A.67.67,0,0,0,0,.67a.64.64,0,0,0,.56.65h2L5.43,9.67a.56.56,0,0,0,.53.38h8.78a.72.72,0,0,0,.67-.63A.76.76,0,0,0,14.75,8.75Zm.89-7.13-9.87-.3a.35.35,0,0,0-.37.51L7,7a.76.76,0,0,0,.76.41H15a.65.65,0,0,0,.63-.56l.52-4.62A.51.51,0,0,0,15.64,1.62Zm-2.23,9.12a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,13.41,10.74Zm-5.34,0a1.35,1.35,0,1,0,1.34,1.35A1.35,1.35,0,0,0,8.07,10.74Z">
              </path>
            </svg></span>
          <span class="buy-now-txt">{{ $t("m.header.buynow") }}</span>
        </a>
      </p>
      <transition name="xwl">
        <nav class="nav" @touchmove.prevent :class="{ drop: navActive }"
          :style="{ height: navActive ? fullHeight + 'px' : 0, 'z-index': 1 }">
          <ul class="nav-ul" @click="navClear()">
            <li v-if="$t('m.lang') == 'en'">
              <a @click="tpProduct()" class="productLi">{{
                  $t("m.header.product")
              }}</a>
            </li>
            <li v-if="$t('m.lang') == 'zh'">
              <a @click="tpProductZh()" class="productLi">{{
                  $t("m.header.product")
              }}</a>
            </li>
            <li v-if="$t('m.lang') == 'en'">
              <a @click="tpSupport()" class="supportLi">{{
                  $t("m.header.support")
              }}</a>
            </li>
            <li v-if="$t('m.lang') == 'zh'">
              <a @click="tpSupportZh()" class="supportLi">{{
                  $t("m.header.support")
              }}</a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer"
                href="https://trello.com/b/l35tWsgf/skybox-vr-video-player-roadmap">{{ $t("m.header.roadmap") }}</a>
            </li>
            <li>
              <a target="_blank" rel="noopener noreferrer" href="https://forum.skybox.xyz/">{{ $t("m.header.forum")
              }}</a>
            </li>
          </ul>
        </nav>
      </transition>
    </section>
  </header>

    <router-view />

  <footer class="footer">
    <section class="footer-content">
      <ul id="menu-footer" class="menu-footer">
        <li id="menu-item" class="menu-item">
          <router-link to="/termsofUse">{{ $t("m.footer.term") }}</router-link>
        </li>
        <li id="menu-item" class="menu-item">
          <router-link to="/en/privacy-policy">{{
              $t("m.footer.pri")
          }}</router-link>
        </li>
        <li id="menu-item" class="menu-item">
          <router-link to="/submit-a-ticket-zh" v-if="$t('m.lang') == 'zh'">{{
              $t("m.footer.content")
          }}</router-link>
          <router-link to="/submit-a-ticket" v-if="$t('m.lang') == 'en'">{{
              $t("m.footer.content")
          }}</router-link>
        </li>
      </ul>
      <p class="copyright">
        <span class="inline-block">© {{ year + " " }} </span>
        <span class="inline-block"> SKYBOX All Rights Reserved.</span>
      </p>
      <nav class="language-switcher" @click="dropOpen()">
        <div class="dropdown-small" :style="{ height: dropdownHeight + 'px' }">
          <p class="current-language select en-us">
            <span class="lang">
              <img :src="langIcon" :alt="lang" />
              {{ lang }}
            </span>
          </p>
          <ul class="language-dropdown" :style="{ 'margin-top': langHeight + 'px' }">
            <li class="lang-item">
              <a lang="en-US" @click="changeLanguageEn()"><img src="./assets/images/flag-us.png" alt="English"
                  title="English" />
                English</a>
            </li>
            <li class="lang-item">
              <a lang="zh-CN" @click="changeLanguageZh(), (langZh = !langZh)" v-if="!langShow"><img
                  src="./assets/images/flag-cn.png" alt="简体中文" title="简体中文" />
                简体中文</a>
            </li>
          </ul>
        </div>
      </nav>
    </section>
  </footer>
</template>

<script>
import { watch } from "@vue/runtime-core";
import i18n from "./lang";

// import { watch } from 'vue'
export default {
  setup() {
    return;
  },
  data() {
    return {
      navActive: false,
      langHeight: "0", //语言选择器高度
      langShow: false, //语言选择器是否展示
      langIcon: require("./assets/images/flag-us.png"), //require为vue3 data中添加路径标配 router中也要这样写
      lang: "English", //当前语言
      svgColor: false, //手机端上导航折叠颜色变化使用 SKYBOX logo颜色
      iconShow: "none", //手机端（小尺寸设备）打开导航栏后关闭（X）键
      dropdownHeight: 28, //语言选择器初始高度 会发生变化
      fullHeight: document.documentElement.clientHeight, //获得用户窗口高度
      year: "",
    };
  },
  created() {
    zE("webWidget", "hide");
    let date = new Date();
    this.year = date.getFullYear();
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    document.addEventListener("click", (e) => {
      let eve = document.querySelectorAll(".current-language")[0];
      let eveOne = document.querySelectorAll(".lang")[0];
      let eveTwo = document.querySelectorAll(".lang")[0].children[0];
      let select = document.querySelectorAll(".dropdown-small")[0];
      if (select.style.height == "56px") {
        if (e.target != eve && e.target != eveOne && e.target != eveTwo)
          this.dropOpen();
      }
    });
  },
  watch: {
    //监听url

    $route(to, from) {
      //老版本页面使用得路径
      if (
        this.$route.path === "/cn" ||
        this.$route.path === "/cn/" ||
        this.$route.path === "/zh/" ||
        this.$route.path ===
        "/cn/support/skybox-vr-video-player-support-ticket/" ||
        this.$route.path === "/cn/support/skybox-vr-video-player-support-ticket"
      ) {
        this.$router.push("/zh");
      }
      if (
        this.$route.path === "/en" ||
        this.$route.path === "/en/" ||
        this.$route.path ===
        "/en/support/skybox-vr-video-player-support-ticket/" ||
        this.$route.path === "/en/support/skybox-vr-video-player-support-ticket"
      ) {
        this.$router.push("/");
      }
      if (
        this.$route.path === "/privacy-policy/" ||
        this.$route.path === "/privacy-policy"
      ) {
        this.$router.push("/en/privacy-policy");
      }
      if (
        this.$route.path === "/termsofUse" ||
        this.$route.path === "/terms-of-use" ||
        this.$route.path === "/terms-of-use/"
      ) {
        this.$router.push("/en/terms-of-use");
      }
      if (
        this.$route.path === "/en/get/" ||
        this.$route.path === "/zh/get" ||
        this.$route.path === "/cn/get" ||
        this.$route.path === "/en/get" ||
        this.$route.path === "/cn/get/" ||
        this.$route.path === "/zh/get/" ||
        this.$route.path === "/get/"
      ) {
        this.$router.push("/get");
      }
      if (
        this.$route.path === "/en/support" ||
        this.$route.path === "/support" ||
        this.$route.path === "/cn/support" ||
        this.$route.path === "/cn/support/"
      ) {
        this.$router.push("/support/");
      }

      if (this.$route.name === "Support-zh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }

      if (this.$route.path === "/zh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }
      if (this.$route.path === "/get-zh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }
      if (this.$route.path === "/search-zh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }
      if (this.$route.name === "contentWebZh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }
      if (this.$route.path === "/submit-a-ticket-zh") {
        this.langIcon = require("./assets/images/flag-cn.png");
        this.langShow = !this.langShow;
        this.lang = "简体中文";
        this.langHeight = 26;
      }
      if (this.$route.path === "/termsofUse") {
        zE("webWidget", "hide");
      }
      if (this.$route.path === "/en/privacy-policy") {
        zE("webWidget", "hide");
      }
    },
  },
  methods: {
    handleResize(event) {
      //监听窗口大小变化
      this.fullHeight = document.documentElement.clientHeight;
    },
    tpSupport() {
      //刷新更新iframe
      // window.location.replace("/en/support");
      window.location.href = "/en/support";
    },
    tpSupportZh() {
      //刷新更新iframe
      window.location.href = "/support-zh/";
    },
    tpGet() {
      //刷新更新iframe
      window.location.href = "/get";
    },
    tpGetZh() {
      //刷新更新iframe
      window.location.href = "/get-zh";
    },
    tpProduct() {
      //刷新更新iframe
      window.location.href = "/";
    },
    tpProductZh() {
      //刷新更新iframe
      window.location.href = "/zh";
    },
    dropOpen() {
      //语言选择器
      if (this.dropdownHeight < 56) {
        this.dropdownHeight = 56;
      } else {
        this.dropdownHeight = 28;
      }
    },
    async changeLanguageZh() {
      //语言切换
      console.log(this.$route);
      i18n.global.locale = "zh";
      this.langIcon = require("./assets/images/flag-cn.png");
      this.langShow = !this.langShow;
      if (this.$route.path === "/submit-a-ticket") {
        window.location.href = "/submit-a-ticket-zh";
      }
      if (this.$route.name === "Support") {
        window.location.href = "/support-zh/";
      }
      if (this.$route.path === "/") {
        window.location.href = "/zh";
      }
      if (this.$route.path === "/get") {
        window.location.href = "/get-zh";
      }
      if (this.$route.path === "/search") {
        window.location.href = "/search-zh?search=";
      }
      if (this.$route.name === "contentWeb") {
        window.location.href =
          `/support-zh/` +
          this.$route.hash.replaceAll(` `, `-`).replaceAll(`/`, `&`) +
          "/";
      }
      this.lang = "简体中文";
      this.langHeight = 26;
    },
    async changeLanguageEn() {
      i18n.global.locale = "en";
      this.langIcon = require("./assets/images/flag-us.png");
      this.langShow = !this.langShow;
      if (this.$route.path === "/submit-a-ticket-zh") {
        window.location.href = "/submit-a-ticket";
      }
      if (this.$route.name === "Support-zh") {
        window.location.href = "/support/";
      }
      if (this.$route.path === "/zh") {
        window.location.href = "/";
      }
      if (this.$route.path === "/get-zh") {
        window.location.href = "/get";
      }
      if (this.$route.path === "/search-zh") {
        window.location.href = "/search?search=";
      }
      if (this.$route.name === "contentWebZh") {
        await this.$http({
          url: "https://64qx6jnt0a.execute-api.cn-north-1.amazonaws.com.cn/Prod/",
          method: "POST",
          data: {
            methods: "changelang",
            langkeys: this.$route.hash,
            lang: "en",
          },
        }).then((res) => {
          window.location.href =
            `/support/` +
            res.data.Items[0].title.replaceAll(` `, `-`).replaceAll(`/`, `&`) +
            "/";
        });
      }
      this.lang = "English";
      this.langHeight = 0;
    },
    navShow() {
      //上导航
      if (this.navActive == false) {
        this.svgColor = true;
        this.iconShow = "inline-block";
        this.navActive = true;
        if (
          this.$route.fullPath == "/submit-a-ticket-zh" ||
          this.$route.fullPath == "/submit-a-ticket"
        ) {
          document.querySelectorAll(".support")[0].style.display = "none";
        }
      } else {
        this.navActive = false;
        this.iconShow = "none";
        if (
          this.$route.fullPath == "/submit-a-ticket-zh" ||
          this.$route.fullPath == "/submit-a-ticket"
        ) {
          setTimeout(() => {
            document.querySelectorAll(".support")[0].style.display = "block";
          }, 150);
        }
        setTimeout(() => {
          this.svgColor = false;
        }, 150);
      }
    },
    navClear() {
      //上导航logo
      if (this.navActive == true) {
        this.svgColor = "";
        this.iconShow = "none";
        this.navActive = false;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/app.scss";
</style>
